import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 0 16px;

  @media (max-width: 600px) {
   padding-top:30px;
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    margin-top: 20px;
    gap: 10px;

  }
`;

const BackButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #000;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 24px;
  font-weight: 800;
  font-family: var(--font-medium);
  cursor: pointer;
  text-decoration: none;
  margin-right: 16px;
  transition: background-color 0.3s;

  @media (max-width: 600px) {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }
`;

const Header = styled.h1`
  font-size: 50px;
  font-family: var(--font-medium);
  color: #fff;
  margin: 0;

  @media (max-width: 600px) {
    font-size: 28px;
  }
`;

const Breadcrumb = styled.nav`
  font-size: 0.9rem;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 8px;
  gap: 5px;

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 5px;
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
    line-height: 1.4;
  }
`;

interface Vehicle {
  year: string;
  make: string;
  model: string;
  stock: string;
  trim: string;
}

const VehicleHeader = ({ vehicle }: { vehicle: Vehicle }) => (
  <HeaderContainer>
    <Breadcrumb aria-label="breadcrumb">
      <Link to="/">Home</Link>
      <FontAwesomeIcon icon={faAngleRight} />
      <span>Inventory</span>
      <FontAwesomeIcon icon={faAngleRight} />
      <span>{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}</span>
      <FontAwesomeIcon icon={faAngleRight} />
      <span>{`Stock: ${vehicle.stock}`}</span>
    </Breadcrumb>
    <TopRow>
      <BackButton to="/" aria-label="Go back">
        <FontAwesomeIcon icon={faAngleLeft} />
      </BackButton>
      <Header>{`${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim}`}</Header>
    </TopRow>
  </HeaderContainer>
);

export default VehicleHeader;
